import { Boxes, CircleDollarSign, ClipboardList, Home, Lock, PenLine, Search, TrendingUp } from "lucide-react";

import Eyebrow from "../../Eyebrow";
import Reveal from "../../Reveal";
import SpotlightCard from "../../SpotlightCard";
import TechNote from "../TechNote";
import { howItWorksSections } from "../../../../content/howItWorksSections";

const icons = { Lock, PenLine, Search, Boxes, TrendingUp, CircleDollarSign, Home, ClipboardList };

/**
 * Guardrail list explaining the human-approval and isolation safeguards.
 * Translation: Guardrail list explaining the human-approval and isolation safeguards.
 *
 * @returns {JSX.Element} Trust section.
 */
const Trust = () => {
  const { trust, techNotes } = howItWorksSections;

  return (
    <section id="trust" className="section-block">
      <div className="section-shell">
        <Reveal>
          <Eyebrow>
            {trust.eyebrowLabel}
            <TechNote>{techNotes[trust.techNote]}</TechNote>
          </Eyebrow>
          <h2 className="section-heading__title">{trust.title}</h2>
        </Reveal>

        <div className="hiw-trust-list">
          {trust.items.map((item, index) => {
            const Icon = icons[item.icon];

            return (
              <Reveal key={item.title} delay={index * 60}>
                <SpotlightCard className="glass-panel hiw-trust-item">
                  <Icon className="hiw-trust-item__icon" strokeWidth={1} />
                  <div>
                    <strong>{item.title}</strong>
                    <p>{item.description}</p>
                  </div>
                </SpotlightCard>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Trust;
